import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
// import AppConfig from "./Config";

export const login = (data) => {
    const { token, username, email, user_type, user_id, company_name, full_name, rememberMe } = data;
    // console.log("login", data)
    const expirationDate = rememberMe ? new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000) : null;
    const cookieOptions = {
        path: '/',
        // secure: true,
        sameSite: 'Lax',
        ...(expirationDate && { expires: expirationDate }), // Pass a Date object if rememberMe is true
    };

    Cookies.set('user_token', token, cookieOptions);
    Cookies.set('username', username, cookieOptions);
    Cookies.set('email', email, cookieOptions);
    Cookies.set('user_type', user_type, cookieOptions);
    Cookies.set('user_id', user_id, cookieOptions);
    Cookies.set('company_name', company_name, cookieOptions);
    Cookies.set('full_name', full_name, cookieOptions);
};
export const setToken = (token) => {
    // console.log("AppConfig.rememberMesetToken", AppConfig.rememberMe)
    const expirationDate = AppConfig.rememberMe
        ? new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000)
        : undefined;
    const cookieOptions = {
        path: '/',
        secure: true,
        sameSite: 'Lax',
        ...(expirationDate && { expires: expirationDate }),
    };

    Cookies.set('user_token', token, cookieOptions);
}
export const settingMenuType = (type) => {
    // console.log("AppConfig.rememberMe", AppConfig.rememberMe)
    const expirationDate = AppConfig.rememberMe
        ? new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000)
        : undefined;
    const cookieOptions = {
        path: '/',
        secure: true,
        sameSite: 'Lax',
        ...(expirationDate && { expires: expirationDate }),
    };

    Cookies.set('type', type, cookieOptions);
}

export const gettingUserFullname = () => {
    return Cookies.get('full_name');
}
export const logout = () => {
    //change this accordingly
    Cookies.remove('user_token');
    Cookies.remove('username');
    Cookies.remove('email');
    Cookies.remove('user_type');
    Cookies.remove('user_id');
    Cookies.remove('full_name');
    Cookies.remove('company_name');
    Cookies.remove('type');

    Cookies.remove('menu_id_add');
    Cookies.remove('menu_id_edit');
    Cookies.remove('menu_id_delete');
    Cookies.remove('excel_export');
    Cookies.remove('admin_menu_data');
    Cookies.remove('admin_permission_data');

    return true;
}

export const isLogin = () => {
    //return true;
    if (Cookies.get('user_token')) { //change this accordingly
        return true;
    }

}

export const getOnlyToken = () => {
    const token = Cookies.get('user_token');
    return token;
}
export const getCustomerId = () => {
    const customerId = parseInt(Cookies.get('user_id'), 10); //change this accordingly

    if (customerId) {
        return customerId;
    } else {
        return null;
    }
};


export const getToken = () => {
    const token = Cookies.get('user_token'); //change this accordingly
    if (token) {
        return {

            headers: {
                Authorization: `${token}`,
            },
        }
    } else {
        return null;
    }
};


export const getLoginData = () => {
    //return true;
    if (Cookies.get('user_id')) {
        const user_data = {
            "auth_user": Cookies.get('auth_user'),
            "username": Cookies.get('username'),
            "user_id": Cookies.get('user_id'),
        };
        return user_data;
    }

}

export const getUserId = () => {
    const user_id = parseInt(Cookies.get('user_id'));

    if (user_id) {
        return user_id;
    } else {
        return null;
    }
};

export const getCompanyName = () => {
    const company_name = Cookies.get("company_name");

    if (company_name) {
        return company_name;
    } else {
        return null;
    }
};

export const setWToken = (token) => {
    if (token) Cookies.set('w_token', token);
}

export const getWToken = () => {
    const token = Cookies.get('w_token');
    return token;
}
export const getUserFullname = () => {
    const token = Cookies.get('full_name');
    return token;
}

// Sweetalert functions

export const triggerAlert = (icon, title, message) => {
    const hasMessage = message !== undefined && message !== null && message !== "";
    return Swal.fire({
        icon: icon,
        title: hasMessage ? title : "",
        text: hasMessage ? message : title,
        timer: 3000,
        customClass: {
            title: "ats-swal-title",
            htmlContainer: "ats-swal-text",
        },
    });
};


export const simpleAlert = (text) => {
    return Swal.fire({
        text: text,
        timer: 3000,
    });
};

export const ConfirmationAlert = async (title, buttonText, buttonFunc) => {
    const result = await Swal.fire({
        title: 'Are you sure?',
        text: title,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: buttonText,
        timer: null,//3000,
    });
    if (result.isConfirmed) {
        buttonFunc();
    }
}

//export to excel functions
export const exportToCsv = (data, filename) => {
    const csvContent = Object.keys(data[0]).join(",") + "\n" +
        data.map(row => Object.values(row).join(",")).join("\n");

    const blob = new Blob([csvContent], { type: 'text/csv' }); // for large amount of data more than 3000 rows
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename + ".csv");
    document.body.appendChild(link);
    link.click();

    // Clean up
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
};

//converting files to base64

export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}
export const formatDate = (dateInput, format) => {

    // If the input is a string, convert it to a Date object
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

    // Check if the date is not null and is a valid Date object
    if (!date || isNaN(date.getTime())) {
        return '-';
    } else {
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December",
        ];

        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
        const monthName = monthNames[date.getMonth()];
        const yyyy = date.getFullYear();

        switch (format) {
            case 'dd-mm-yyyy':
                return `${dd}-${mm}-${yyyy}`;
            case 'yyyy-mm-dd':
                return `${yyyy}-${mm}-${dd}`;
            case 'dd/mm/yyyy':
                return `${dd}/${mm}/${yyyy}`;
            case 'mm/dd/yyyy':
                return `${mm}/${dd}/${yyyy}`;
            case 'month dd, yyyy':
                return `${monthName} ${dd}, ${yyyy}`;
            // Add more format cases as needed
            default:
                return `${dd}-${mm}-${yyyy}`;
        }
    }
};

// Formatting date and time
export const formatDateTime = (dateTimeInput, format) => {
    let date;

    // Handle different formats of dateTimeInput
    if (typeof dateTimeInput === 'string') {
        // Case when dateTimeInput includes 'T' (ISO 8601 format)
        if (dateTimeInput.includes('T')) {
            [date] = dateTimeInput.split('T');
            date = new Date(dateTimeInput);
        } else {
            // Handle cases like 'Thu Aug 22 2024 18:44:49 GMT+0530 (India Standard Time)'
            date = new Date(dateTimeInput);
        }
    } else {
        // If it's not a string, assume it's a Date object
        date = new Date(dateTimeInput);
    }

    // Validate the date object
    if (!date || isNaN(date.getTime())) {
        return '-';
    }

    // Date components
    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const monthName = month[date.getMonth()];

    // Time components (default to 00:00:00 if not provided)
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Return formatted date and time based on the specified format
    switch (format) {
        case 'dd-mm-yyyy':
            return `${dd}-${mm}-${yyyy}`;
        case 'yyyy-mm-dd':
            return `${yyyy}-${mm}-${dd}`;
        case 'dd/mm/yyyy':
            return `${dd}/${mm}/${yyyy}`;
        case 'mm/dd/yyyy':
            return `${mm}/${dd}/${yyyy}`;
        case 'month dd, yyyy':
            return `${monthName} ${dd}, ${yyyy}`;
        case 'yyyy-mm-dd, hh:mm:ss':
            return `${yyyy}-${mm}-${dd}, ${hours}:${minutes}:${seconds}`;
        case 'yyyy-mm-dd hh:mm:ss':
            return `${yyyy}-${mm}-${dd} ${hours}:${minutes}:${seconds}`;
        case 'hh:mm:ss':
            return `${hours}:${minutes}:${seconds}`;
        case 'mm-dd-yyyy':
            return `${mm}-${dd}-${yyyy}`;
        case 'month dd, hh:mm':
            return `${monthName} ${dd}, ${hours}:${minutes}`;


        // Add more format cases as needed
        default:
            return '-';
    }
};

//remove html tags 
export const removePTags = (inputString) => {
    if (inputString) {
        // Remove HTML tags
        const withoutPTags = inputString.replace(/<\/?[^>]+(>|$)/g, "");
        // Remove &nbsp;
        const removeBraces = withoutPTags.replace(/&nbsp;/g, '');
        return removeBraces;
    }
}

//download files
export const downloadFile = async (url, filename) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('File fetch failed');
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl); // Clean up memory
  } catch (error) {
    console.error('Error downloading file:', error);
    // Optional fallback: open the file in new tab
    window.open(url, '_blank');
  }
};

//row selection 
export const handleTableRowClick = (value, selectedRow, setSelectedRow, selectedRowId, setSelectedRowId, row_id) => {
    // console.log("handleTableRowClick", value)
    if (selectedRowId === row_id) {
        setSelectedRow();
        setSelectedRowId();
    } else {
        setSelectedRow(value);
        setSelectedRowId(row_id);
    }

};

//generate random password of given characters
export const generatePassword = (noOfChar) => {
    // Use crypto.getRandomValues() for cryptographically strong randomness
    const randomValues = new Uint8Array(noOfChar);
    crypto.getRandomValues(randomValues);

    // const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*_+-?'; // Include symbols for stronger passwords
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; // removed symbols 
    const password = Array.from(randomValues, (value) => charset[value % charset.length]).join('');

    return password;
}

export const togglePasswordVisibility = (inputId, class_name) => {
    const passwordInput = document.getElementById(inputId);
    const inputClass = document.querySelector(`.${class_name}`);
    // console.log(inputClass)
    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        inputClass.classList.add('bx-show');
        inputClass.classList.remove('bx-hide');
    } else {
        passwordInput.type = 'password';
        inputClass.classList.remove('bx-show');
        inputClass.classList.add('bx-hide');
    }
};

///transform strings
export function transformText(text, transformation) {
    if (!text) console.error("unable to retrieve the text");
    switch (transformation) {
        case 'lowercase':
            return text.toLowerCase();
        case 'uppercase':
            return text.toUpperCase();
        case 'capitalize':
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        default:
            throw new Error(`Invalid transformation: ${transformation}`);
    }
}

///extract filename 
export function extractFileName(url) {
    const parts = url?.split('/');
    return parts[parts?.length - 1];
}


export const pageReload = () => {
    setTimeout(() => {
        window.location.reload();
    }, 1000);

}

export const AlertWithButton = async (title, htmlCode, buttonText, buttonFunc) => {
    const result = await Swal.fire({
        title: title,
        html: htmlCode,
        confirmButtonText: buttonText,
    });
    if (result.isConfirmed) {
        buttonFunc();
    }
}



export const formattedDateTime = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month starts from 0
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export function formatTimeToAmandPM(dateString) {
    const date = new Date(dateString);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedTime = hours + ':' + formattedMinutes + ' ' + ampm;
    return formattedTime;
}
export const truncateName = (message, length = 50) => {
    if (message?.length > length) {
        return message.substring(0, length) + '...';
    }
    return message;
};




// Function to extract latitude and longitude from the URL
export const extractCoordinates = (url) => {
    const regex = /place\/(-?\d+\.\d+),(-?\d+\.\d+)/;
    const match = url.match(regex);
    if (match) {
        return {
            latitude: match[1],
            longitude: match[2],
        };
    }
    return { latitude: null, longitude: null };
};

// Function to get formatted date as Today, Yesterday, day of the week, or mm-dd-yyyy
export const getFormattedDate = (date) => {
    const messageDate = new Date(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize today to midnight
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Check if the message date is today
    if (messageDate.toDateString() === today.toDateString()) {
        return 'Today';
    }

    // Check if the message date is yesterday
    if (messageDate.toDateString() === yesterday.toDateString()) {
        return 'Yesterday';
    }

    // Check if the message is within the current week
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay()); // Set to the start of the week (Sunday)

    if (messageDate >= startOfWeek) {
        return messageDate.toLocaleString('en-US', { weekday: 'long' }); // Return the day name
    }

    // For older messages, return the formatted date
    return formatDateTime(messageDate, 'mm-dd-yyyy');
};

export const formatCount = (count) => {
    if (count >= 1000000) {
        // Format millions
        return (count / 1000000).toFixed(1) + 'M';
    } else if (count >= 1000) {
        // Format thousands
        return (count / 1000).toFixed(1) + 'K';
    } else {
        // Return the number as is if less than 1000
        return count.toString();
    }
};
export const validateFileSize = (value) => {
    if (!value) return true; // Allow empty files
    const fileSize = value[0]?.size; // Access the size property of the File object
    const maxFileSize = 1024 * 1024; // 1 MB
    if (fileSize > maxFileSize) {
        return 'File size exceeds the maximum allowed size (1 MB).';
    }
    return true;
};

export function sendNotification(title, message) {
    if ('Notification' in window) {
        Notification.requestPermission().then(permission => {
            // console.log('Notification permission:', permission); // Check permission status
            if (permission === 'granted') {
                new Notification(title, {
                    body: message,
                    icon: '/path/to/icon.png',// Optional: include an icon
                });
            } else {
                console.log('Permission denied or dismissed');
            }
        }).catch(error => {
            console.error('Notification request failed:', error);
        });
    } else {
        console.log('Notification API not supported in this browser.');
    }
}

export const getInitials = (str) => {
    if (!str) return '-'; // Return '-' if the string is empty or undefined

    return str
        .split(' ')  // Split the string into words
        .slice(0, 3) // Take the first 3 words
        .map((word) => word[0].toUpperCase()) // Get the first letter of each word and convert to uppercase
        .join(''); // Join the initials into a single string
};

export const setCookie = (name, value, days = 7) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
};

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return '';
};

export const ConfirmationAlerts = async (title, buttonText, buttonFunc) => {
    const result = await Swal.fire({
        title: 'Are you sure?',
        text: title,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: buttonText,
        cancelButtonText: 'Cancel',
        timer: null,// 3000,
    });

    if (result.isConfirmed) {
        buttonFunc();
    }
};


export const exportPdf = (selectedData, data, filename, dynamicColumns) => {
    import("jspdf").then((jsPDF) => {
        import("jspdf-autotable").then(() => {
            const doc = new jsPDF.default('l', 'mm', 'a4'); // landscape mode

            const exportColumns = dynamicColumns?.map(col => ({
                title: col.header,
                dataKey: col.field
            }));

            const dataToExport = selectedData.length > 0 ? selectedData : data;

            const columnStyles = {};
            exportColumns.forEach(col => {
                columnStyles[col.dataKey] = {
                    cellWidth: 'wrap', // allow wrapping
                    minCellHeight: 10,
                };
            });
doc.autoTable({
  columns: exportColumns,
  body: dataToExport,
  styles: { fontSize: 7, cellPadding: 2, overflow: 'linebreak' },
  columnStyles,
  margin: { top: 20, left: 10, right: 10 },
  startY: 20,
  horizontalPageBreak: true, // 👈 splits columns into new pages
  horizontalPageBreakRepeat: 1, // 👈 repeats headers on each page
});


            doc.save(filename);
        });
    });
};



        const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], { type: EXCEL_TYPE });
                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };

   export const exportExcel = (selectedData, data, filename) => {
        import('xlsx').then((xlsx) => {
            const dataToExport = selectedData.length > 0 ? selectedData : data; 
            const worksheet = xlsx.utils.json_to_sheet(
                dataToExport.length > 0 ? dataToExport : [{ message: "No data to export" }]
            );
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });
            saveAsExcelFile(excelBuffer, filename);
        });
    };




//lokesh

export const set_user_menu_permission = (menu_id_add, menu_id_edit, menu_id_delete, view_permissions) => {
    setCookie('menu_id_add', JSON.stringify(menu_id_add));
    setCookie('menu_id_edit', JSON.stringify(menu_id_edit));
    setCookie('menu_id_delete', JSON.stringify(menu_id_delete));
    setCookie('view_permissions', JSON.stringify(view_permissions));
    window.dispatchEvent(new Event('user-menu-permissions-updated'));
}

export const get_user_menu_permission = (menu_id, type) => {
    // If user is a customer, grant all permissions
    // if (isCustomerUser()) {
    //     return true;
    // }

    // For sub-users, check their specific permissions
    let has_permission = false;
    if (type === "add") {
        const add_permissions = JSON.parse(getCookie('menu_id_add') || '[]');
        has_permission = add_permissions.includes(Number(menu_id));
    } else if (type === "edit") {
        const edit_permissions = JSON.parse(getCookie('menu_id_edit') || '[]');
        has_permission = edit_permissions.includes(Number(menu_id));
    } else if (type === "delete") {
        const delete_permissions = JSON.parse(getCookie('menu_id_delete') || '[]');
        has_permission = delete_permissions.includes(Number(menu_id));
    } else if (type === "view") {
        const view_permissions = JSON.parse(getCookie('view_permissions') || '[]');
        has_permission = view_permissions.includes(Number(menu_id));
    }
    return has_permission;
};

